import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router';
import useMount from '../../common/hooks/useMount';
import {
  resetEventAuditLogs,
  resetSingleEvent,
} from '../../redux/actions/eventsActions';
import EventDetails from './EventDetails';
import EventAuditTrail from './EventAuditTrail';

const mapDispatchToProps = {
  resetSingleEvent,
  resetEventAuditLogs,
};

const portletConfig = {
  tabs: ['Event Details', 'Audit Trail'],
  actionsLabel: 'Actions',
  actions: [],
};

function Event(props) {
  const { id: eventId } = useParams();
  const [activeTab, setActiveTab] = useState(0);

  const location = useLocation();
  const basePath = `/${location.pathname.split('/')[1]}`;

  useMount(() => () => {
    props.resetSingleEvent();
    props.resetEventAuditLogs();
  });

  const childrenProps = {
    eventId,
    portletConfig,
    activeTab,
    onTabClick: setActiveTab,
    originPath: basePath,
  };

  return (
    <div className="row">
      <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
        {activeTab === 0 && <EventDetails {...childrenProps} />}
        {activeTab === 1 && <EventAuditTrail {...childrenProps} />}
      </div>
    </div>
  );
}

export { Event as EventUnconnected };

export default connect(null, mapDispatchToProps)(Event);



// WEBPACK FOOTER //
// ./src/js/views/event/Event.jsx